import React from "react";

// Extend the Window interface to include openTerminal
declare global {
  interface Window {
    openTerminal?: () => void;
  }
}

interface ConfigurationMenuProps {
  onMenuItemClick?: () => void;
  onUnitConfigClick?: () => void;
}

const ConfigurationMenu: React.FC<ConfigurationMenuProps> = ({
  onMenuItemClick,
  onUnitConfigClick,
}) => {
 


  const handleUnitConfigClick = () => {
    // Close the configuration menu dropdown first
    if (onMenuItemClick) {
      onMenuItemClick();
    }

    // Then open the unit config dialog
    if (onUnitConfigClick) {
      onUnitConfigClick();
    }
  };

  return (
    <div className="absolute top-full left-0 mt-1 w-48 bg-gray-800 border border-gray-700 rounded shadow-lg z-50">
      <button
        onClick={handleUnitConfigClick}
        className="w-full text-left px-4 py-2 hover:bg-gray-700 text-gray-200 text-sm"
      >
        Unit Configuration
      </button>
      <button
        onClick={() => {
          if (onMenuItemClick) onMenuItemClick();
          if (window.openTerminal) window.openTerminal();
        }}
        className="w-full text-left px-4 py-2 hover:bg-gray-700 text-gray-200 text-sm"
      >
        Terminal
      </button>
    </div>
  );
};

export default ConfigurationMenu;
